import { useGetConfiguracionesPropinaQuery } from "src/gql/schema"
import { useProfile } from "src/shared/hooks/useProfile"
import Screen from "src/shared/components/layout/screen/Screen"
import "./ConfigPropinas.css"
import InputTabs from "src/shared/components/forms/input-tabs/InputTabs"
import { useState } from "react"
import Comisiones from "./components/comisiones/Comisiones"
import Pagos from "./components/pagos/Pagos"

const ConfigPropinas = () => {
    const [tab, setTab] = useState<string>("comisiones")
    const tabs = [
        { label: "Comisiones", value: "comisiones" },
        { label: "Pagos a colaboradores", value: "pagos" },
    ]
    
    const { hotel_id } = useProfile()
    const { data: fetchConfig, refetch } = useGetConfiguracionesPropinaQuery({ variables: { hotel_id } })

    const refetchConfig = () => refetch()

    const props = {
        config: fetchConfig?.configuraciones_propina,
        refetchConfig
    }

    return (
        <Screen className="config-propinas__layout" title="Configuración de propinas" close>
            <InputTabs
                containerClassName="config-propinas__tabs"
                label={""}
                items={tabs}
                value={tab}
                onChange={(value) => {
                    if(!value) return
                    setTab(value)
                }}
            />
            {tab === "comisiones" ? <Comisiones {...props} /> : <Pagos {...props} />}
        </Screen>
    )
}

export default ConfigPropinas